import { useMemo } from 'react';
import { useUserSetting } from './use-user-setting';
import { Provider } from '../constants/shipping-grouping';
import { useSelector } from 'react-redux';
import Global from '../store/global-selectors';
import { useIsVendorOr3PL } from './use-is-vendor-or-3pl';

const SHARED_CARRIER_IDS = ['109', '116', '117', '145', '146', '149', '150'];

const filterProviderOrCarrierGroup = (groupByUserSetting, providerOrCarrierGroups) => {
  if (groupByUserSetting === Provider) {
    return providerOrCarrierGroups.filter((service) => !service.name.startsWith('Client'));
  }
  return providerOrCarrierGroups.filter((service) => !SHARED_CARRIER_IDS.includes(service.groupId));
};

export const useGetInitialShippingServiceGroups = (providerOrCarrierGroups, merchantServicesRequired) => {
  const groupByUserSetting = useUserSetting('ShippingServiceGrouping') || Provider;
  const sharedServices = useSelector(Global.selectCarrierSharingserviceGroups);
  const isVendorOr3PL = useIsVendorOr3PL();

  const choosenServices = useMemo(() => {
    if (!isVendorOr3PL || !Array.isArray(sharedServices) || !sharedServices.length) {
      return providerOrCarrierGroups;
    }

    if (merchantServicesRequired) {
      return sharedServices;
    }

    const filteredProviderOrCarrierGroups = filterProviderOrCarrierGroup(groupByUserSetting, providerOrCarrierGroups);

    return sharedServices.concat(filteredProviderOrCarrierGroups);
  }, [isVendorOr3PL, sharedServices, merchantServicesRequired, providerOrCarrierGroups, groupByUserSetting]);

  return choosenServices;
};
